import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appDropdownFocus]'
})
export class DropdownFocusDirective {
    constructor(private el: ElementRef, private renderer: Renderer2) { }

    @HostListener('focusout', ['$event'])
    onFocusOut(event: FocusEvent) {
        const dropdownMenu = this.el.nativeElement.querySelector('.dropdown-menu');
        // Verifica se l'evento focusout proviene dall'interno del dropdown
        if (dropdownMenu && !dropdownMenu.contains(event.relatedTarget)) {
            // Trova tutti gli elementi <a> all'interno del dropdown con data-toggle="dropdown"
            const toggleLink = this.el.nativeElement.querySelector('a[data-toggle="dropdown"]');
            if(this.renderer) {
                // Imposta aria-expanded="false" per tutti gli elementi trovati
                this.renderer?.setAttribute(toggleLink, 'aria-expanded', 'false');
                // Rimuovi la classe "open" dall'elemento dropdown
                this.renderer?.removeClass(this.el.nativeElement, 'open');
            }
        }
    }
}